import { createFileRoute, redirect } from '@tanstack/react-router'
import { CashCustodyDetail } from '@/features/hr-cash-custody/custody-detail'
import { hasGrant } from '@/lib/me'

/** Route shell for one cash custody and its statement. */
export const Route = createFileRoute('/_authenticated/hr/cash-custody/$custodyId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'cash_custody.view')) {
      throw redirect({ to: '/hr' })
    }
  },
  component: CashCustodyDetailRoute,
})

function CashCustodyDetailRoute() {
  const { custodyId } = Route.useParams()

  return <CashCustodyDetail custodyId={custodyId} />
}
